import { sendTips } from 'api/worker'
import { formatCurrency } from 'lib/string'
import { QueryFnData } from 'queries/types'

type SendTipsResult = QueryFnData<typeof sendTips>

/** Extracts error messages and success count from work history result */
export const parseSendTipsResult = (data: SendTipsResult) =>
  data.workHistory.reduce<{
    successes: number
    errorMessages: string[]
  }>(
    (acc, item) => {
      if (item.error) {
        const { amount, error } = item.error
        acc.errorMessages.push(
          `Could not send ${formatCurrency(amount)} to ${
            item.work.worker.name || 'worker'
          }: ${error}\n\nPlease contact WorkWhile Support.`
        )
      } else {
        acc.successes += 1
      }
      return acc
    },
    { successes: 0, errorMessages: [] }
  )
